const Sentry = require('@sentry/browser');
const { removeTokenValue } = require('./token-helper');

const sanitizeBreadcrumb = breadcrumb => {
  const { category } = breadcrumb;

  // Remove query parameters (may contain PII) and tokens of Fetch and XHR breadcrumb categories.
  if (category === 'fetch' || category === 'xhr') {
    if (breadcrumb.data) {
      const sanitizedUrl = breadcrumb.data.url.split('?');
      // eslint-disable-next-line no-param-reassign
      breadcrumb.data.url = removeTokenValue(sanitizedUrl[0]);
    }
  }

  // Removing console entries because we don't know what kind of information
  // we're leaking and we don't want to allow any accidental future uses of
  // console to create PII concerns.
  if (category === 'console') {
    return null;
  }

  return breadcrumb;
};

const init = function(t) {
  Sentry.init({
    beforeBreadcrumb(breadcrumb) {
      return sanitizeBreadcrumb(breadcrumb);
    },
    beforeSend(event) {
      // returning null will cause an event to not be sent
      // let's use that to de-noise our events
      if (event.exception) {
        const stringifiedErr = JSON.stringify(event.exception);
        if (/chrome-extension:/i.test(stringifiedErr)) {
          return null;
        }
      }
      if (event.extra) {
        const stringifiedExtra = JSON.stringify(event.extra);
        if (/chrome-extension:/i.test(stringifiedExtra)) {
          return null;
        }
      }
      return event;
    },
    dsn: 'https://981081e24de84222aa8b8ed9597dc5e9@o55978.ingest.sentry.io/5988936',
    environment: 'production',
  });

  Sentry.configureScope(function(scope) {
    let version = 'unknown';
    const urlParts = /^https:\/\/app\.butlerfortrello\.com\/([\w-]+)\//.exec(window.location.href);
    if (urlParts && urlParts[1]) {
      [, version] = urlParts;
    }

    if (window.TrelloPowerUp) {
      scope.setTag('TrelloPowerUp', window.TrelloPowerUp.version);
    }
    if (t.isMemberSignedIn()) {
      scope.setUser({ id: t.getContext().member });
    }
    scope.setTag('buildDate', 'undefined');
    scope.setTag('version', version);
    const context = t.getContext() || {
      version: 'unknown',
      board: '',
      enterprise: 'Non-enterprise',
    };
    scope.setTag('webClient', context.version);
    scope.setTag('idBoard', context.board);
    scope.setTag('idEnterprise', context.enterprise);
    try {
      scope.setTag('embedded', window.location !== window.parent.location);
      if (window.location !== window.parent.location) {
        scope.setTag('referrer', document.referrer);
      }
    } catch (err) {
      // noop
    }
  });

  window.isSentryInitialized = true;
};

const SentryInitializer = {
  init,
};

window.SentryInitializer = SentryInitializer;
module.exports = SentryInitializer;
